export function ServicesList(state = [], action) {
    switch (action.type) {
        case 'ADD_SERVICES':
            return addServices(state, action.arr)
            break
        default:
            return state
    }
}

function addServices(state, arr) {
    return [].concat(state, arr)
}
